/**
 * Adresa unui fisier static al aplicatiei: o foaie, un font, o imagine, un
 * plugin. Toate stau in `v4/web/public/` si se servesc de sub `base`-ul
 * aplicatiei (`/app/` - vezi `base` din vite.config.ts).
 *
 * DE CE NU SE MAI SCRIE `/public/...`
 * -----------------------------------------------------------------------------
 * Pana pe 14 septembrie 2026 aplicatia cerea foile, fonturile, imaginile si
 * pluginurile de la RADACINA site-ului portalului vechi (`/public/css/app.css`,
 * `/public/images/header/...`, `/images/logo/...`). Portalul CodeIgniter va fi
 * oprit, si atunci toate cererile alea se intorc goale: ecranul ramane
 * nestilat, fara sigle, fara grafice. Decizia Roxanei: v4 nu ia NIMIC de la
 * portal la rulare. Copiile stau in `public/` de langa aplicatie si pleaca in
 * `dist/` odata cu ea.
 *
 * Calea se da RELATIV la `public/` (`css/adm.css`, `images/header/x.png`),
 * fara `/` in fata; prefixul il pune functia, o singura data, aici. Proba
 * `src/ui/portalAssets.test.ts` refuza orice `'/public/` sau `'/images/`
 * scris din nou ca sir in `src/`.
 */
export function assetUrl(path: string): string {
  return import.meta.env.BASE_URL + path.replace(/^\/+/, '')
}
